import { ConfirmationEditMessage } from "@components/Common/ConfirmationEditMessage";
import React from "react";
import { ConfirmationModificationMessage } from "./ConfirmationModificationMessage";
import { ConfirmationAssociateBoutique } from "../ShopsDevise/ConfirmationAssociateBoutique";
import { ConfirmationModal } from "./ConfirmationModal";

const ConfirmationModals = ({
    // Edit
    isModalOpened,
    setIsModalOpened,
    setIsAddDeviceClicked,
    setDevises,

    // Modification
    isModalOpen,
    setIsModalOpen,
    setIsEdited,
    setDataIsUpdated,
    dataEdited,
    associated,

    // Associate Boutique
    isMessageModalOpened,
    setIsMessageModalOpened,
    setTagsData,
    setInputSymbol,
    setDesignation,
    setCountryData,
    setDecimalNumber,
    setDecimalDesignation,
    setChange,
    setTag,
    setSymbol,
    setIsSendingTag,
    setLocalFilterActive,
    designation,
    change,
    tagsData,
    allDataShops,
    countryData,
    t,

    // Archive
    isArchivedFranchiseModalOpened,
    setIsArchivedFranchiseModalOpened,
}: any) => {
    return (
        <React.Fragment>
            <ConfirmationEditMessage
                isModalOpened={isModalOpened}
                setIsModalOpened={setIsModalOpened}
                setIsAddClicked={setIsAddDeviceClicked}
                setEditedData={setDevises}
            />

            {isModalOpen && (
                <ConfirmationModificationMessage
                    isModalOpened={isModalOpen}
                    setIsModalOpened={setIsModalOpen}
                    setIsEdited={setIsEdited}
                    setDataIsUpdated={setDataIsUpdated}
                    dataModeSale={dataEdited}
                    shopId={associated}
                    setIsAddDeviceClicked={setIsAddDeviceClicked}
                />
            )}

            {isMessageModalOpened && (
                <ConfirmationAssociateBoutique
                    msg={t(
                        "The currency already exists in the franchise. Do you want to associate it with this shop"
                    )}
                    setIsModalOpened={setIsMessageModalOpened}
                    isModalOpened={isMessageModalOpened}
                    setTagsData={setTagsData}
                    setInputSymbol={setInputSymbol}
                    setDesignation={setDesignation}
                    setCountryData={setCountryData}
                    setDecimalNumber={setDecimalNumber}
                    setDecimalDesignation={setDecimalDesignation}
                    setChange={setChange}
                    setTag={setTag}
                    setSymbol={setSymbol}
                    setDataIsUpdated={setDataIsUpdated}
                    setIsEdited={setIsEdited}
                    setIsSendingTag={setIsSendingTag}
                    setLocalFilterActive={setLocalFilterActive}
                    designation={designation}
                    change={change}
                    tagsData={tagsData}
                    allDataShops={allDataShops}
                    countryData={countryData}
                />
            )}

            {isArchivedFranchiseModalOpened && (
                <ConfirmationModal
                    isConfirmationModal={isArchivedFranchiseModalOpened}
                    setIsConfirmationModal={setIsArchivedFranchiseModalOpened}
                />
            )}
        </React.Fragment>
    );
};

export default ConfirmationModals;
